import { LANGUAGE } from "./actions";

enum Langs {
  It = "it",
  Es = "es",
}

export interface IDialogState {
  language: Langs;
}

const initialState: IDialogState = {
  language: localStorage.getItem("lang"),
};

export const languageSelector = (state: IDialogState = initialState, action): IDialogState => {
  switch (action.type) {
    case LANGUAGE.SET_LANGUAGE: {
      return {
        ...state,
        language: action.payload,
      };
    }
    default:
      return state;
  }
};
